module.exports = __webpack_public_path__ + "static/assets/506c5a55f7956d6548af06160f800ecc.png";